import React, { PureComponent } from "react";
import FormFields from "../fields/FormFields";
import memoize from "lodash/memoize";
import { replaceValues, replaceObjectValues } from "./utils";

function getItemFields(fields, name, index) {
  const itemFields = fields.map(field => ({
    ...field,
    condition: field.condition ? { ...field.condition, key: `${name}[${index}][${field.condition.key}]` } : undefined,
    fields: field.fields ? getItemFields(field.fields, name, index) : undefined,
    name:
      field.type !== "Fields" && field.type !== "Column" && field.type !== "Columns" && field.type !== "Tab"
        ? `${name}[${index}][${field.name || ""}]`
        : ""
  }));
  return itemFields;
}

class Accordion extends PureComponent {
  static defaultProps = {
    defaultOpen: false
  };
  state = {
    open: this.props.defaultOpen
  };

  render() {
    const { domRef, header, isOpen, children, onToggle } = this.props;
    return (
      <div ref={domRef} className="af-team__accordion">
        <div style={{ display: "table-cell", verticalAlign: "top" }}>
          <div className="af-team__accordion__header" onClick={onToggle} style={{ cursor: "pointer" }}>
            {header}
          </div>
          <div className="af-team__accordion__content" style={{ display: isOpen ? "block" : "none" }}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

function computeMaxCount(maxItems, data) {
  if (typeof maxItems === "string") {
    const n = Number(replaceValues(maxItems, data));
    if (Number.isNaN(n)) return 0;
    return n;
  }
  return maxItems;
}

export default class ListItem extends PureComponent {
  state = {
    openedIndex: undefined
  };

  static defaultProps = {
    itemLabel: "entrée"
  };

  openedElement = React.createRef();

  getItems() {
    const { data, name } = this.props;
    return data[name] || [];
  }

  getMaxCount() {
    const { maxItems, data } = this.props;
    return computeMaxCount(maxItems, data);
  }

  componentDidMount() {
    const {
      valueIfEmpty,
      data,
      onChange,
      name,
      // maxLabel = "Vous ne pouvez plus rajouter d'entrées",
      minItems
    } = this.props;
    // Init ?
    const items = this.getItems();
    if (minItems && items.length == 0 && valueIfEmpty) {
      onChange(
        name,
        valueIfEmpty.map(item => replaceObjectValues(item, data))
      );
      this.setState({
        openedIndex: 0
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { data, name, onChange } = nextProps;
    const items = data[name] || [];
    const maxItems = computeMaxCount(nextProps.maxItems, data);
    if (maxItems && items.length > maxItems) {
      onChange(name, items.slice(0, maxItems)); // Limit length !
    }
    // TODO : add item if missing ? Don't mess with componentDidMount though...
  }

  handleAddItem = () => {
    const { valueIfEmpty, data, onChange, name, maxLabel = "Vous ne pouvez plus rajouter d'entrées" } = this.props;
    const items = this.getItems();
    const maxItems = this.getMaxCount();
    if (items.length === 0 && valueIfEmpty) {
      onChange(
        name,
        valueIfEmpty.map(item => replaceObjectValues(item, data))
      );
      this.setState({ openedIndex: 0 });
    } else {
      if (!maxItems) {
        onChange(name, [...items, {}]);
      } else {
        if (items.length < maxItems) {
          onChange(name, [...items, {}]);
        } else {
          alert(maxLabel);
        }
      }
      this.setState(
        {
          openedIndex: items.length // Open new one
        },
        this.scrollToOpenElement
      );
    }
  };

  scrollToOpenElement = () => {
    // Scroll to top of item
    const el = this.openedElement.current;
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }
  };

  handleDelete = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const { onChange, name, deleteText = "Etes-vous sûr de vouloir supprimer cette entrée ?" } = this.props;
    const items = this.getItems().slice(0);
    if (window.confirm(deleteText)) {
      items.splice(index, 1);
      onChange(name, items);
    }
  };

  handleToggle = index => {
    const { openedIndex } = this.state;
    if (openedIndex === index) {
      this.setState({ openedIndex: undefined });
    } else {
      this.setState({ openedIndex: index }, this.scrollToOpenElement);
    }
  };

  render() {
    const { minItems, name, fields, data, emptyLabel, itemLabel, itemHeaderDetails, onChange, lockList } = this.props;
    const items = this.getItems();
    const { openedIndex } = this.state;
    const maxItems = this.getMaxCount();

    // console.log(minItems, items.length, maxItems);
    return (
      <div className="af-field-container--ListItem">
        {maxItems && (
          <h4 style={{ margin: 0 }} className="af-maxItems">
            MAX : {maxItems} {itemLabel}
            {maxItems === 1 ? "" : "s"}
          </h4>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <h3 style={{ flex: 1 }}>
            {items.length} {itemLabel}
            {items.length === 1 ? "" : "s"}
          </h3>
          {this.renderButton(items)}
        </div>
        {items.map((m, index) => {
          const headerTitle = replaceValues(itemHeaderDetails, m);
          const hasInfo = !!headerTitle.trim();
          const isOpen = openedIndex === index;
          const memo = memoize(getItemFields);
          const itemFields = memo(fields, name, index);
          return (
            <Accordion
              key={index}
              style={{ margin: 0 }}
              isOpen={isOpen}
              domRef={isOpen ? this.openedElement : undefined}
              header={
                <div className="af-team__header">
                  <h3 style={{ margin: 0, flex: 1 }}>
                    <span style={{ display: "inline-block", width: 20, textAlign: "right" }}>{index + 1}.</span>
                    {hasInfo ? ` ${headerTitle}` : ` ${emptyLabel || ""} ${index + 1}`}
                  </h3>
                  {!lockList && (!minItems || items.length > minItems) /* only delete if not last required one */ && (
                    <i className="fa fa-trash" style={{ marginRight: 10 }} onClick={e => this.handleDelete(e, index)} />
                  )}
                  <i className={`fa fa-chevron-${isOpen ? "down" : "right"}`} />
                </div>
              }
              onToggle={() => this.handleToggle(index)}
            >
              <FormFields fields={itemFields} data={data} onChange={onChange} />
            </Accordion>
          );
        })}
        {items.length > 0 && <div style={{ marginTop: 16 }}>{this.renderButton(items)}</div>}

        {minItems && items.length < minItems && (
          <div className="af-message af-message--error">
            Vous devez avoir au moins {minItems} {itemLabel}
          </div>
        )}
        {maxItems && items.length > maxItems && (
          <div className="af-message af-message--error">
            Vous devez avoir moins de {maxItems} {itemLabel}
          </div>
        )}
      </div>
    );
  }

  renderButton(items) {
    const { itemLabel, buttonText = "Ajouter un", lockList } = this.props;
    if (lockList) return null; // Closed...
    const maxItems = this.getMaxCount();
    if (maxItems && items.length >= maxItems) return null; // Can't add !
    return (
      <button type="button" className="af-team__button" onClick={this.handleAddItem}>
        <i className="fa fa-plus" style={{ marginRight: 5 }} />
        {buttonText} {(itemLabel || "").toLowerCase()}
      </button>
    );
  }
}
